import BookDetail from "./book-datail.page";

export default BookDetail;
